import { Injectable } from '@angular/core';
import { UpdatePassword } from '../change-password/models/password.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private privateToken: string;
  public credentials: UpdatePassword = {
    oneloginId: null,
    otpToken: '',
    password: '',
    password2: '',
  };

  constructor(private http: HttpClient) {}

  public setPrivateToken(token: string): void {
    this.privateToken = token;
  }
  public getPrivateToken(): string {
    return this.privateToken;
  }

  public resetPasswordLogin(): Observable<any> {
    return this.http.post(`${environment.apiAuthUrl}/auth/onelogin/reset-password-login`, {});
  }
}
